import React from "react";
import NavMenu from "./NavMenu";
import {useSelector} from "react-redux";
import {RootState} from "../../store/rootReducer";
import SettingFocusHost from "../Common/SettingFocusHost";
import SupportSessionBanner from "./SupportSessionBanner";

/**
 * The authenticated shell.
 *
 * The Adaptive Intelligence surface is a light-dismiss panel launched from the nav bar rather than a
 * dock that squeezes the page, so nothing here reserves width for it. The chat dock components are
 * still in the tree under components/AdaptiveIntelligence, simply unmounted.
 *
 * Note this component is mounted twice in Router.tsx, so it remounts when a navigation crosses that
 * boundary. Nothing that must survive a route change may live in component state here.
 */
const Layout: React.FC = (props) => {
    const auth = useSelector((state: RootState) => state.auth);

    return (
        <>
        {auth.isAuthed && <>
            <SupportSessionBanner />
            <NavMenu />
            <div className="all-content">
                {props.children}
            </div>
            {/* One host for every authenticated screen; SettingsLayout renders inside this one. */}
            <SettingFocusHost /></>}
        </>
    );
};

export default Layout;
